import { Flex, mdBumps, Typo, xxlBumps } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useCancelPolicyAdjustment } from '../../../../hooks/actions/cancel'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { toDateTime } from '../../../../util/date'
import { ActionBar } from '../../../organisms/form'
import { FullPage } from '../../../templates'
import { PolicyPath } from '../PolicyPath'

const tKey = TKey('pages.cancel-confirm')

export const CancellationConfirmPage: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  const navigate = useNavigate()

  const {
    state: { cancellationReason, dateTime },
  } = useLocation()

  const onDismiss = useCallback(() => navigate('../..'), [navigate])
  const onConfirm = useCancelPolicyAdjustment(cancellationReason, dateTime, () => {
    navigate(['..', '..', PolicyPath.CANCEL_CONFIRMATION].join('/'))
  })

  return (
    <FullPage header={t(tKey('header'))} pageId='cancel-confirm'>
      <Flex width={1} variant='raised' px={mdBumps} py={5} mb={xxlBumps}>
        <Typo fontWeight='bold'>{t(tKey('effective.header'))}</Typo>
        <Typo>
          {dateTime
            ? t(tFormats('datetime.medium'), { value: toDateTime(dateTime) })
            : t(tKey('effective.immediate'))}
        </Typo>
      </Flex>

      <ActionBar
        tKey={tKey}
        destructive={true}
        onConfirm={onConfirm.execute}
        loading={onConfirm.loading}
        onDismiss={onDismiss}
      />
    </FullPage>
  )
}
